export enum ActionTypes {
  // the 'GetPremierPackages' action is for loading state
  GetPremierPackages = 'getPremierPackages',
  GetPremierPackagesRequest = 'getPremierPackages.request',
  GetPremierPackagesSuccess = 'getPremierPackages.success',
  GetPremierPackagesFailure = 'getPremierPackages.failure',
}
